var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 5.16667C10.6654 6.63943 9.47146 7.83333 7.9987 7.83333C6.52594 7.83333 5.33203 6.63943 5.33203 5.16667C5.33203 3.69391 6.52594 2.5 7.9987 2.5C9.47146 2.5 10.6654 3.69391 10.6654 5.16667Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 9.83203C5.42137 9.83203 3.33203 11.9214 3.33203 14.4987H12.6654C12.6654 11.9214 10.576 9.83203 7.9987 9.83203Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.28dd3e521e0a9556640b1b30e154b0b6.svg";
export { ForwardRef as ReactComponent };